import React from 'react'
import { TopNavigationBar } from '../api/settings'

export default React.createContext<TopNavigationBar[]>([])
